import i18n from '@/utils/i18n';
import {
  FULFILLMENT_SHIPPING_TYPES,
  TranslationArgs,
} from '@domain/fulfillment-settings/blocs/order-availability';
import { FulfillmentName } from '@/types';

export const translateFulfillmentType = (
  fulfillmentType: FulfillmentName,
  keyPrefix: string,
  displayName?: string | null,
  translationArgs?: TranslationArgs,
) => {
  const showDate =
    Boolean(translationArgs?.date) &&
    !FULFILLMENT_SHIPPING_TYPES.includes(fulfillmentType);
  const translationSuffix = displayName
    ? showDate
      ? 'custom_with_date'
      : 'custom'
    : fulfillmentType.toLowerCase();
  const translationKey = `${keyPrefix}.${translationSuffix}`;

  const finalTranslationArgs = {
    ...translationArgs,
    ...(displayName ? { name: displayName } : {}),
  };

  const translation = i18n.t(translationKey, finalTranslationArgs);
  return translation === translationKey
    ? // Translation doesn't exist so fall back to delivery
      i18n.t(`${keyPrefix}.delivery`, finalTranslationArgs)
    : translation;
};
